import React from 'react';
import { graphql } from 'gatsby';
import VehicleLayout from '../layouts/vehicle';
import '../fragments/vehicleGatsby';
import '../fragments/vehiclePreviewGatsby';

export const query = graphql`
  query EaSingleVehicle($id: ID!, $relatedVehiclesWhere: STRAPI_JSON) {
    strapi {
      head: vehicle(id: $id) {
        id
        ...VehicleHead
      }

      vehicle(id: $id) {
        ...Vehicle
      }

      specs: vehicle(id: $id) {
        ...VehicleSpecs
      }

      leases(where: { vehicle: $id }) {
        price
        formUrl
      }

      relatedVehicles: vehicles(limit: 4, where: $relatedVehiclesWhere) {
        id
        ...VehiclePreview
      }
    }
  }
`;

const Vehicle = ({ data }) => (
  <VehicleLayout {...data.strapi} />
);

export default Vehicle;
